export const config = {
	defaultSortName: "meetingDate",
	defaultSortDirection: "desc" as const,
	defaultPageNumber: 1,
	pageSize: 25,
	statusOptions: ["active", "completed", "canceled", "archived"] as const,
};
